module.exports = __webpack_public_path__ + "static/media/gold-chips-big-img.545f70eb.svg";